import { Quiz, QuizSubmitData, StatisticData } from '../models/Course';

const lmsBaseUrl = __JS_ENV_VARS__['JS_ENV_LMS_BASE_URL'];
const accessToken = localStorage.getItem('access_token');

export async function quizMap(
  courseId: number | string,
): Promise<Record<string, string>> {
  const url = new URL(`${lmsBaseUrl}/wp-json/mybrightlink/v1/course/steps`);
  url.searchParams.append('course_id', courseId.toString() ?? '0');
  url.searchParams.append('mbl_web', '1');

  const res = await fetch(url.toString(), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const json = await res.json();
  const quizIdList = json['h']['sfwd-lessons'];

  const lessonQuizMap: Record<string, string> = {};

  Object.keys(quizIdList).forEach((key) => {
    const quizIdMap = quizIdList[key]['sfwd-quiz'];
    lessonQuizMap[key] = Object.keys(quizIdMap)[0];
  });

  return lessonQuizMap;
}

export async function quizQuestion(quizId: number | string): Promise<Quiz[]> {
  const quizUrl = new URL(
    `${lmsBaseUrl}/wp-json/mybrightlink/v1/quiz/question`,
  );
  quizUrl.searchParams.append('quiz', quizId.toString() ?? '0');
  quizUrl.searchParams.append('mbl_web', '1');

  const resp = await fetch(quizUrl.toString(), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await resp.json();
}

export async function markComplete(lessonId: number | string) {
  const quizUrl = new URL(
    `${lmsBaseUrl}/wp-json/mybrightlink/v1/quiz/mark_complete`,
  );
  quizUrl.searchParams.append('mbl_web', '1');
  await fetch(quizUrl.toString(), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ post: lessonId }),
  });
}

export async function submitQuiz(
  lessonId: string,
  quizId: string,
  data: QuizSubmitData[],
) {
  const quizUrl = new URL(`${lmsBaseUrl}/wp-json/mybrightlink/v1/quiz/submit`);
  quizUrl.searchParams.append('mbl_web', '1');
  await fetch(quizUrl.toString(), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      lesson_id: lessonId,
      quiz: quizId,
      results: data,
    }),
  });
}

export async function updateCompletion(lessonId: string, quizId: string) {
  const quizUrl = new URL(
    `${lmsBaseUrl}/wp-json/mybrightlink/v1/quiz/update_completion`,
  );
  quizUrl.searchParams.append('mbl_web', '1');
  await fetch(quizUrl.toString(), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      lesson_id: lessonId,
      quiz: quizId,
    }),
  });
}

export async function quizStatistic(quizId: string, data: StatisticData) {
  const quizUrl = new URL(
    `${lmsBaseUrl}/wp-json/mybrightlink/v1/quiz/statistic`,
  );
  quizUrl.searchParams.append('mbl_web', '1');

  await fetch(quizUrl.toString(), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      quizId: quizId,
      data: data,
    }),
  });
}
